export const NavbarLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Catalog",
    // path: '/catalog',
  },
  {
    title: "About Us",
    path: "/About-us",
  },
  // {
  //   title: "Contact Us",
  //   path: "/contact",
  // },
];
